<template>
  <span>
    <div v-if="machineStates.includes('loading')" class="loading">
      <loading-spinner />
      <translate>Waiting for location...</translate>
    </div>
    <translate v-else>Use my location</translate>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class GeolocationState extends Vue {
  @Prop()
  machineStates: string[]
}

export default toNative(GeolocationState)
</script>
<style scoped>
.loading {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.loading :deep(svg) {
  height: 1.2em;
  width: auto;
  margin: 0 0.3em 0 0;
}
</style>
